<div class="card h-100">
  <div class="card-body d-flex">
    <div class="d-flex flex-column w-100 h-100">
      <!-- Image -->
      <div class="col-sm-12 mb-0 cursor-pointer">
        <img [src]="
            data.image_url
              ? fileUrl + data.image_url
              : './assets/media/svg/files/blank-image.svg'
          " class="course-card__thumb rounded-nested bg-light min-h-200px" [attr.alt]="data.name" />
      </div>
      <!-------->
      <div class="col-sm-12 d-flex flex-column justify-content-between flex-grow-1 pt-8">
        <div class="mb-4">
          <div class="mb-6">
            <p
              class="text-gray-800 text-hover-primary min-h-40px fs-3 fw-bold lh-1 mb-2 cursor-pointer text-overflow-line-2">
              {{ data.name }}
            </p>
            <div class="text-gray-700 text-overflow-line-5 fs-5 fw-normal mb-0" [innerHTML]="data.explain">
              <!-- {{ data.explain }} -->
            </div>
          </div>
        </div>
        <div #button_group class="col-12 border-top pt-5">
          <!-- Left-aligned, like everything above it. The block used to be
               centred inside a left-aligned card, which put the duration and
               the price on an axis of their own and made the card read as two
               designs stacked. -->
          <div class="d-flex align-items-end justify-content-between gap-3 mb-5">
            <div class="d-flex flex-column gap-2">
              <!-- Meta, at meta size. This was `fs-2 fw-bold` — a 20px bold
                   grey "2ม." sitting directly above the price and reading as
                   the card's headline. -->
              <span class="course-card__meta fs-7">
                {{ data.duration_video? (data.duration_video | durationVideo) : '0น.' }}
              </span>

              <div class="d-flex flex-row flex-wrap align-items-baseline gap-2">
                <!-- A free course showed as "฿0.00", which reads as a pricing
                     bug rather than as free. -->
                @if (pricing().price > 0) {
                <span class="course-card__price" [ngClass]="pricing().hasDiscount ? 'text-danger' : 'text-gray-900'">{{
                  pricing().price | currency : "฿" }}</span>
                } @else {
                <span class="course-card__price text-success">{{ "APP.FREE" | translate }}</span>
                }
                @if(pricing().hasDiscount){
                <span class="fw-semibold text-decoration-line-through text-gray-400 fs-5 lh-1">{{
                  pricing().originalPrice | currency : " " }}</span>
                }
              </div>
            </div>
          </div>

          <!-- Tonal. Four of these sit in a row and each one is the same
               offer; solid brand fills turn the row into a stripe and leave the
               price — the thing being decided — as the quietest element in the
               card. Amber stays reserved for ratings and warnings. -->
          <button type="button" class="btn btn-light-primary rounded-pill w-100 fw-bold fs-5">
            {{ "APP.BUY_NOW" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>